export default __webpack_public_path__ + "static/media/slider-2.3e209b71.png";